"use strict";

import cc from "./helpers";
import gsap from "gsap";

const updateColor = function (a, el, c) {
	const currBaseColor = c[a];
	const currLightColor = cc.changeColorHex(currBaseColor, 100, 98);
	const darkColor = cc.changeColorHex(currBaseColor, 49, 65);

	const tl = gsap.timeline();

	tl.to(el[1], { "--top": currBaseColor, "--bottom": currLightColor, duration: 1 });

	if (el[2]) {
		el[2].querySelector("path").style.fill = darkColor;
	}

	el[0].forEach((slide, i) => {
		if (i === a) {
			slide.style.backgroundColor = darkColor;
			slide.style.cursor = "initial";
		} else {
			slide.style.backgroundColor = `${cc.changeColorHex(currBaseColor, 25, 85)}`;
			slide.style.cursor = "pointer";
		}
	});
};

export default updateColor;
